export function updateDailyClosedChat(data) {
  return {
    type: '@UPDATE_DAILY_CLOSED_CHAT',
    payload: {
      data
    }
  };
}

export function getDailyClosedChat(data) {
  return {
    type: '@GET_DAILY_CLOSED_CHAT',
    payload: {
      data
    }
  };
}
